module.exports = __webpack_public_path__ + "static/img/3.5d139379.png";